import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  return <section className="py-24 bg-navy-light relative overflow-hidden" data-id="element-27">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-28"></div>
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#D4A85A 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-29"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10 text-center" data-id="element-30">
        <FadeIn data-id="element-31">
          <h2 className="text-4xl md:text-5xl font-black text-beige mb-4" data-id="element-32">
            Tu primera canción está más cerca de{' '}
            <span className="text-gold" data-id="element-33">lo que creés</span>
          </h2>
          <p className="text-xl text-beige/70 mb-4" data-id="element-34">
            No dejes pasar más tiempo. El mejor momento para empezar fue ayer,
            el segundo mejor momento es hoy.
          </p>
          <p className="text-lg text-beige/50 italic mb-12" data-id="element-35">
            Disfrutá tocar piano sin presión, a tu ritmo y desde tu casa.
          </p>

          <CTAButton className="py-5 px-10 text-xl shadow-xl" data-id="element-36">
            QUIERO TOCAR MI PRIMERA CANCIÓN
          </CTAButton>
          <p className="text-sm text-beige/50 mt-4" data-id="element-37">
            Acceso inmediato – empezás hoy mismo
          </p>
        </FadeIn>
      </div>
    </section>;
}